import * as React from 'react'
import { Link } from '@lacedltd/laced-components'

import * as S from './ProductPriceBreakdown.styles'
import type { FullPriceBreakdown } from 'types/priceFunctionBreakdown'

// for internal use only, so no translations added
const ProductPriceBreakdown: React.FC<Props> = ({ fullPriceBreakdown }) => {
  const sellerPageHref = `/admin/users/${fullPriceBreakdown.seller_id}/selling?status=active`

  return (
    <S.AccordionRoot type="single">
      <S.AccordionItem
        title={
          <S.AccordionTitle as="p" variant="body">
            Price breakdown
          </S.AccordionTitle>
        }
        sectionName="breakdown-section"
      >
        <S.BreakdownTable>
          <thead>
            <tr>
              <S.TableRowHeader width={10}>Step</S.TableRowHeader>
              <S.TableRowHeader width={45}>Function</S.TableRowHeader>
              <S.TableRowHeader width={20}>Input price</S.TableRowHeader>
              <S.TableRowHeader width={25}>Output price</S.TableRowHeader>
            </tr>
          </thead>
          <tbody>
            {fullPriceBreakdown.function_breakdowns.map((fnBreakdown) => (
              <React.Fragment key={fnBreakdown.function_name}>
                <S.BreakdownRow>
                  <td>{fnBreakdown.function_step_no}</td>
                  <td>{fnBreakdown.function_name}</td>
                  <td>{fnBreakdown.input_price}</td>
                  <td>{fnBreakdown.output_price}</td>
                </S.BreakdownRow>
                {Object.entries(fnBreakdown.breakdown).map(([key, value]) => (
                  <S.DetailedBreakdownRow key={key}>
                    <td colSpan={2}>{key}</td>
                    <td colSpan={2}>{value?.toString()}</td>
                  </S.DetailedBreakdownRow>
                ))}
              </React.Fragment>
            ))}
            <S.BreakdownRow>
              <td colSpan={4}>
                Sale collection id: {fullPriceBreakdown.sale_collection_id},
                auth region: {fullPriceBreakdown.auth_centre_region}
              </td>
            </S.BreakdownRow>
            <S.BreakdownRow hasBorder={false}>
              <td colSpan={4}>
                <Link href={sellerPageHref} size="m" underline>
                  View this seller listing page
                </Link>
              </td>
            </S.BreakdownRow>
          </tbody>
        </S.BreakdownTable>
      </S.AccordionItem>
    </S.AccordionRoot>
  )
}

export default ProductPriceBreakdown

interface Props {
  fullPriceBreakdown: FullPriceBreakdown
}
